import type { Event, Store } from 'effector'
import React from 'react'

export function useWatcher<T>(unit: Store<T> | Event<T>, watcher: (data: T) => any) {
    React.useEffect(() => unit.watch(watcher), [unit, watcher])
}

export function useWatcherOnce<T>(unit: Store<T> | Event<T>, watcher: (data: T) => boolean) {
    const isActiveRef = React.useRef(true)
    React.useEffect(
        () =>
            unit.watch((data) => {
                if (isActiveRef.current) {
                    const shouldStop = watcher(data)
                    isActiveRef.current = !shouldStop
                }
            }),
        [unit, watcher]
    )
}
